function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _templateObject() {
  var data = _taggedTemplateLiteral(["", ""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { getBreakpoints } from "../../../theme/selectors";
import { themeConfig } from "../../../theme";
import { mediaQueryFunctionsList } from "../../../theme/helpers";
import { addStyle } from "../../../utils/styledComponents";

var addPlainGridStyle = function addPlainGridStyle(propName, propValue, propsDict, theme, transformStyle) {
  if (transformStyle) {
    return transformStyle(propsDict[propName], propValue, theme);
  }

  return addStyle(propsDict[propName], String(propValue));
};

var addAdaptiveGridStyles = function addAdaptiveGridStyles(propName, propObj, theme, propsDict, transformStyle) {
  var breakpoints = getBreakpoints(theme);
  /* eslint-disable @typescript-eslint/no-explicit-any */

  var mediaQueries = mediaQueryFunctionsList(breakpoints);
  return Object.keys(propObj).filter(function (breakpoint) {
    return themeConfig.breakpointNames.includes(breakpoint);
  }).map(function (breakpoint) {
    var propValue = propObj[breakpoint];
    var plainStyles = addPlainGridStyle(propName, propValue, propsDict, theme, transformStyle);
    return mediaQueries[breakpoint](_templateObject(), plainStyles);
  });
};

export var createGridStyle = function createGridStyle(propName, propsDict, transformStyle) {
  return function (props) {
    var propValue = props[propName];

    if (propValue) {
      if (_typeof(propValue) === 'object') {
        return addAdaptiveGridStyles(propName, propValue, props.theme, propsDict, transformStyle);
      }

      return addPlainGridStyle(propName, propValue, propsDict, props.theme, transformStyle);
    }
  };
};